import React, { memo, SVGProps } from 'react'

export const Facility = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M21.7655 19.4387H20.968V10.7327C20.968 10.4279 20.8036 10.1528 20.5448 10.0264L12.7345 6.16413V3.78132C12.7345 3.51367 12.6051 3.26833 12.3952 3.12335C12.1819 2.97838 11.9161 2.95979 11.6922 3.07503L3.4552 7.14551C3.19637 7.2719 3.03198 7.5507 3.03198 7.8518V19.4387H2.23451C1.82878 19.4387 1.5 19.7882 1.5 20.2194C1.5 20.6506 1.82878 21 2.23451 21H21.7655C22.1712 21 22.5 20.6506 22.5 20.2194C22.5 19.7882 22.1712 19.4387 21.7655 19.4387ZM4.501 8.34992L11.2655 5.00432V19.4387H4.501V8.34992ZM12.7345 19.4387V7.88526L19.499 11.2309V19.4387H12.7345Z"
      fill="currentColor"
    />
    <path
      d="M9.05496 15.2047H6.70803C6.3023 15.2047 5.97352 15.5541 5.97352 15.9853C5.97352 16.4165 6.3023 16.766 6.70803 16.766H9.05496C9.46069 16.766 9.78947 16.4165 9.78947 15.9853C9.78947 15.5541 9.46069 15.2047 9.05496 15.2047Z"
      fill="currentColor"
    />
    <path
      d="M9.05496 12.3014H6.70803C6.3023 12.3014 5.97352 12.6509 5.97352 13.0821C5.97352 13.5133 6.3023 13.8627 6.70803 13.8627H9.05496C9.46069 13.8627 9.78947 13.5133 9.78947 13.0821C9.78947 12.6509 9.46069 12.3014 9.05496 12.3014Z"
      fill="currentColor"
    />
    <path
      d="M17.2885 15.2047H14.9415C14.5358 15.2047 14.207 15.5541 14.207 15.9853C14.207 16.4165 14.5358 16.766 14.9415 16.766H17.2885C17.6942 16.766 18.023 16.4165 18.023 15.9853C18.023 15.5541 17.6942 15.2047 17.2885 15.2047Z"
      fill="currentColor"
    />
    <path
      d="M17.2885 12.3014H14.9415C14.5358 12.3014 14.207 12.6509 14.207 13.0821C14.207 13.5133 14.5358 13.8627 14.9415 13.8627H17.2885C17.6942 13.8627 18.023 13.5133 18.023 13.0821C18.023 12.6509 17.6942 12.3014 17.2885 12.3014Z"
      fill="currentColor"
    />
    <path
      d="M9.05496 9.39821H6.70803C6.3023 9.39821 5.97352 9.74764 5.97352 10.1788C5.97352 10.6101 6.3023 10.9595 6.70803 10.9595H9.05496C9.46069 10.9595 9.78947 10.6101 9.78947 10.1788C9.78947 9.74764 9.46069 9.39821 9.05496 9.39821Z"
      fill="currentColor"
    />
  </svg>
))
